var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "pdp-gallery",
      class: { "pdp-gallery--zooming": _vm.zoomState }
    },
    [
      _c("div", { staticClass: "pdp-gallery__main-container" }, [
        _c(
          "div",
          { staticClass: "pdp-gallery__main" },
          [
            _c(
              "div",
              { staticClass: "pdp-gallery__badge-container" },
              _vm._l(_vm.badges, function(badge) {
                return _vm.variant
                  ? _c("div", {
                      key: badge,
                      staticClass: "badge",
                      class: [_vm.$store.state.badgeColorMap[badge]]
                    })
                  : _vm._e()
              }),
              0
            ),
            _vm.zoomState
              ? _c(
                  "span",
                  {
                    staticClass: "pdp-gallery__zoom-icon",
                    on: {
                      click: function() {
                        return (_vm.zoomState = false)
                      }
                    }
                  },
                  [_c("icon", { attrs: { name: "zoom_out", size: "30px" } })],
                  1
                )
              : _c(
                  "span",
                  {
                    staticClass: "pdp-gallery__zoom-icon",
                    on: { click: _vm.zoomCenter }
                  },
                  [_c("icon", { attrs: { name: "zoom_in", size: "30px" } })],
                  1
                ),
            _c(
              "swiper",
              {
                key: _vm.mainSwiperKey,
                ref: "swiper",
                attrs: { options: _vm.swiperOptionsMain }
              },
              [
                _vm.productMedia.length > 1
                  ? _c("div", {
                      staticClass: "text-center pdp-gallery__pagination",
                      attrs: { slot: "pagination" },
                      slot: "pagination"
                    })
                  : _vm._e(),
                _vm._l(_vm.productMedia, function(media, index) {
                  return _c("swiper-slide", { key: media.id }, [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.setZoom($event, !_vm.zoomState)
                          },
                          mouseleave: function() {
                            return (_vm.zoomState = false)
                          }
                        }
                      },
                      [
                        _c(
                          "media",
                          { attrs: { media: media } },
                          [
                            _c("zoom", {
                              ref: "zoom",
                              refInFor: true,
                              attrs: {
                                slot: "image",
                                "img-normal-attrs": {
                                  src: _vm.imageSize(media.src, "800x"),
                                  alt: _vm.getProductImageAlt(media)
                                },
                                "img-zoom-attrs": {
                                  src: _vm.imageSize(media.src, "1500x"),
                                  alt: _vm.getProductImageAlt(media),
                                  loading: "lazy"
                                },
                                zooming: _vm.zoomState,
                                disabled: !_vm.zoomState
                              },
                              slot: "image"
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                })
              ],
              2
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pdp-gallery__thumbs" },
          [
            _c(
              "swiper",
              {
                key: _vm.thumbSwiperKey,
                ref: "thumbSwiper",
                staticClass: "pdp-gallery__thumbs-slider",
                attrs: { options: _vm.swiperOptionThumbs }
              },
              _vm._l(_vm.productMedia, function(media, index) {
                var _obj
                return _c(
                  "swiper-slide",
                  {
                    key: media.src,
                    class:
                      ((_obj = {
                        "pdp-gallery__thumbs-slide--active":
                          _vm.slideIndexMain === index
                      }),
                      (_obj[_vm.settings.thumbnailColor] =
                        _vm.slideIndexMain === index),
                      _obj)
                  },
                  [
                    _c(
                      "button",
                      {
                        attrs: { "aria-label": "Go to Thumbnail " + index },
                        on: {
                          click: function($event) {
                            return _vm.thumbSlideTo(index)
                          }
                        }
                      },
                      [
                        _c("media-preview", {
                          attrs: { media: media, size: "83x131" }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }